
export default async(props = ['name', 'email', 'tel', 'address', 'icon'], opts = {multiple: true}) => {
  try {
    if('contacts' in navigator && 'ContactsManager' in window){
        let contacts = await navigator.contacts.select(props, opts);
        /*if (contacts.length > 0) {
          const contact = contacts[0];
          const contactNumber = contact.tel.filter(tel => tel.length > 0)[0];
          const contactName = contact.name.filter(name => name.length > 0)[0];
          if (contactNumber) {
            phoneNumInput.value = contactNumber.replace(/\s/g, "");
            dialBtn.innerText = `Dial ${contactName}`;
          }
        }*/
        return contacts;
        //handleResults(contacts);
    }else{
        throw "Sorry, the contact picker API is not supported in your browser.";
    }
  } catch (ex) {
      // Handle any errors here.
      throw ex;
  }
}
